// components/NoteTitleBar.js
import React, { useState, useEffect } from 'react';
import styles from './NoteTitleBar.module.css';
import { useNotes } from './contexts/NotesContext';
import { useCategories } from './contexts/CategoriesContext';
import SubnoteBreadcrumb from './SubnoteBreadcrumb';

const NoteTitleBar = () => {
  // Use our new specific update functions instead of generic updateNote
  const { getSelectedNote, updateNoteTitle, updateNoteCategory, selectedNoteId } = useNotes();
  const { categories } = useCategories();
  const currentNote = getSelectedNote();
  
  // Use local state to ensure immediate UI updates
  const [title, setTitle] = useState('');
  const [categoryId, setCategoryId] = useState('');
  
  // Update local state when the selected note changes
  useEffect(() => {
    if (currentNote) {
      setTitle(currentNote.title || '');
      setCategoryId(currentNote.primary_category_id || '');
    }
  }, [currentNote, selectedNoteId]);
  
  if (!currentNote) return null;
  
  
  const handleTitleChange = (e) => {
    const newTitle = e.target.value;
    // Update local state immediately
    setTitle(newTitle);
    // Use our new function to update context and API
    updateNoteTitle(currentNote.id, newTitle);
  };
  
  const handleCategoryChange = (e) => {
    const newCategoryId = e.target.value;
    // Update local state immediately
    setCategoryId(newCategoryId);
    // Use our new function to update context and API
    updateNoteCategory(currentNote.id, newCategoryId);
  };

  const isSubnote = !!currentNote.parent_id;
  

  return (
    <div className={styles.noteTitleBarWrapper}>
      {/* Show breadcrumb for subnotes */}
      {isSubnote && <SubnoteBreadcrumb />}
      
      <div className={styles.noteTitleBar}>
        <input
          type="text"
          className={styles.titleInput}
          value={title}
          onChange={handleTitleChange}
          placeholder="Untitled"
        />
        <select 
          className={styles.categorySelect}
          value={categoryId}
          onChange={handleCategoryChange}
        >
          {categories?.map((category) => (
            <option key={category.id} value={category.id}>
              {category.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default NoteTitleBar;